// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1eaov","header":"MergedInvoice_header__1MHLU"};